/*
|--------------------------------------------------------------------------
| Utilities: Fetch: Handlebars View
|--------------------------------------------------------------------------
*/
/**
 * Get a view from handlebars
 * @namespace
 * @param {object} options
 * @param {string} options.view - name of handlebars view
 * @param {string} options.data - data to pass to the view
 */
__gh__webApp.utilities.fetch.handlebarsView = {

	/**
	 * Initialize
	 */
	"init": function(){
		this.registerHelpers();
		//Make all handlebars views available as partials
	    Handlebars.partials = Handlebars.templates;
	},


	/**
	 * Register Handlebars Helpers
	 */
	"registerHelpers": function() {
		var helpers = this.handlebarsHelpers;
		for (var helper in helpers) {
		  helpers[helper]();
		}
	},


	/**
	 * Handlebars helper functions that can be used in handlebars views
	 */
	"handlebarsHelpers": {
		/**
		 * Call a partial dynamically
		 * Slightly modified from https://gist.github.com/adjohnson916/7266137
		 * @param {String} name Name of a previously registered partial.
		 * @param {Object} [context] Optional context object to use as variable scope when rendering partial.
		 * @example
		 * {{#dynamicPartial view.name thisORanotherObject}}{{/dynamicPartial}}
		 */
		"dynamicPartial": function(){
			Handlebars.registerHelper("dynamicPartial", function (name, context, options) {
			    // defaults
			    context = context || {};

			    // fallback to normal partial
			    var partial = Handlebars.partials[name];

			    // return empty string if partial not defined
			    if (! partial) return "";
			    // else call the partial

			    return partial.call(null, context, options);
			});
		},


		/**
		 * Makes it possible to use if conditions that can compare two values
		 * @example
		 * {{#ifCond v1 '>' v2}}true{{else}}false{{/ifCond}}
		 */
		"ifCond": function(){
			Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
			    switch (operator) {
			        case '==':
			            return (v1 == v2) ? options.fn(this) : options.inverse(this);
			        case '===':
			            return (v1 === v2) ? options.fn(this) : options.inverse(this);
			        case '<':
			            return (v1 < v2) ? options.fn(this) : options.inverse(this);
			        case '<=':
			            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
			        case '>':
			            return (v1 > v2) ? options.fn(this) : options.inverse(this);
			        case '>=':
			            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
			        case '&&':
			            return (v1 && v2) ? options.fn(this) : options.inverse(this);
			        case '||':
			            return (v1 || v2) ? options.fn(this) : options.inverse(this);
			        default:
			            return options.inverse(this);
			    }
			});
		},


		/**
		 * Decodes HTML in handlebars variable
		 * @example, variable {{pubdate}} = 1/2/13 at 9:30&nbsp;am
		 * @prints 1/2/13 at 9:30 am
		 * {{html_decoder pubdate}}
		 */
		"html_decoder": function(){
			Handlebars.registerHelper('html_decoder', function(text) {
				var str = unescape(text).replace(/&amp;/g, '&'),
					div = document.createElement('div');
					div.innerHTML = str;
				return div.firstChild.nodeValue;
			});
		},


		/**
		 * Allows you to check within an array for a value
		 * @example
		 * {{#ifIn id [array]}}true{{else}}false{{/ifIn}}
		 */
		"ifIn": function(){
			Handlebars.registerHelper('ifIn', function(elem, list, options) {
			  if(list.indexOf(elem) > -1) {
			    return options.fn(this);
			  }
			  return options.inverse(this);
			});
		},
		
		
		/**
		 * Generate random true and false
		 * https://triangle717.wordpress.com/2014/10/02/js-randomly-generate-a-boolean-value/
		 * https://jsfiddle.net/67h8f2ve/
		 * @example
		 * {{#ifRandomTrue}} left{{else}} right{{/ifRandomTrue}}
		 */
		"ifRandomTrue": function() {
			Handlebars.registerHelper('ifRandomTrue', function(options) {
				var randomTrue = Boolean(Math.floor(Math.random() * 2));
				if(randomTrue){
					return options.fn(randomTrue);
				}
				return options.inverse(randomTrue);
			});
		},
		
		
		/**
		 * Limit the 'each' loop.
		 * {numeric} [offset=0] - offset by a number of items
		 * {numeric} [limit=5] - limit the total number returned
		 * @example
		 *	{{#limit items offset="1" limit="5"}} : items 1 thru 6
		 * @example
		 * {{#limit items limit="10"}} : items 0 thru 9
		 * @example
		 * {{#limit items offset="3"}} : items 3 thru context.length
		 */

		"limit": function(){
			Handlebars.registerHelper('limit', function(context, block) {
			  var ret = "",
			      offset = parseInt(block.hash.offset) || 0,
			      limit = parseInt(block.hash.limit) || 5,
			      i = (offset < context.length) ? offset : 0,
			      j = ((limit + offset) < context.length) ? (limit + offset) : context.length;

			  for(i,j; i<j; i++) {
			    ret += block(context[i]);
			  }

			  return ret;
			});
		},

		/*
		 * Do math in handlebars
		 * http://jsfiddle.net/mpetrovich/wMmHS/
		 * @example
		 * {{math @index "+" 1}}
		 */
		"math": function(){
			Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
			    lvalue = parseFloat(lvalue);
			    rvalue = parseFloat(rvalue);

			    return {
			        "+": lvalue + rvalue,
			        "-": lvalue - rvalue,
			        "*": lvalue * rvalue,
			        "/": lvalue / rvalue,
			        "%": lvalue % rvalue
			    }[operator];
			});

		},

		/*
		 * Stringify an object or an array.
		 * @example
		 * {{ JSON2string object }}
		 */
		"JSON2string": function(){
			Handlebars.registerHelper('JSON2string', function (arrayObject) {
			    return JSON.stringify(arrayObject);
			});
		},


		/*
		* Repeat given markup with given times
		* Provides @index for the repeated iteraction
		*/
		"repeat": function(){
		 	Handlebars.registerHelper("repeat", function (times, opts) {
			    var out = "";
			    var i;
			    var data = {};

			    if (times) {
			        for ( i = 0; i < times; i += 1 ) {
			            data.index = i;
			            out += opts.fn(this, {
			                data: data
			            });
			        }
			        return out;
			    }

			    return opts.inverse(this);

			});
		 }
	},

	/**
	 * Add the view after a dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.view - name of handlebars view
	 * @param {string} options.data - data to pass to the view
	 * @param {string} options.dom - dom to append the view to
	 */
	"after": function(options){
		var view 	= (options.view) 	? options.view : null,
		 	data 	= (options.data) 	? options.data : [],
		 	dom 	= (options.dom)		? options.dom : null;

		var html 	= __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});

		$(dom).after(html);
	},

	/**
	 * Append the view to a dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.view - name of handlebars view
	 * @param {string} options.data - data to pass to the view
	 * @param {string} options.dom - dom to append the view to
	 */
	"append": function(options){
		var view 	= (options.view) 	? options.view : null,
		 	data 	= (options.data) 	? options.data : [],
		 	dom 	= (options.dom)		? options.dom : null;

		var html 	= __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});

		$(dom).append(html);
	},


	/**
	 * Prepend the view to a dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.view - name of handlebars view
	 * @param {string} options.data - data to pass to the view
	 * @param {string} options.dom - dom to append the view to
	 */
	"prepend": function(options){
		var view 	= (options.view) 	? options.view : null,
		 	data 	= (options.data) 	? options.data : [],
		 	dom 	= (options.dom)		? options.dom : null;

		var html 	= __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});

		$(dom).prepend(html);
	},


	/**
	 * Replace dom content with view
	 * @namespace
	 * @param {object} options
	 * @param {string} options.view - name of handlebars view
	 * @param {string} options.data - data to pass to the view
	 * @param {string} options.dom - dom to replace content
	 */
	"replace": function(options){
		var view 	= (options.view) 	? options.view : null,
		 	data 	= (options.data) 	? options.data : [],
		 	dom 	= (options.dom)		? options.dom : null;

		var html 	= this.get({
			"view": view,
			"data": data
		});

		$(dom).html(html).fadeIn("slow");
	},


	/**
	 * Get a view from handlebars
	 * @namespace
	 * @param {object} options
	 * @param {string} options.view - name of handlebars view
	 * @param {string} options.data - data to pass to the view
	 */
	"get": function(options){
		var view 	= (options.view) ? options.view : null,
		 	data 	= (options.data) ? options.data : [];

		if (!view || view=="" || view=="none") {
			 console.log("View is not set.")
			 console.log(data);
			 return;
		}

		return Handlebars.templates[view](data);
	}
};
